import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { rootRoute } from '../__root';

const acceptInviteSearchSchema = z.object({
  token: z.string().optional(),
});

export const acceptInviteRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/auth/accept-invite',
  validateSearch: acceptInviteSearchSchema,
  component: lazyRouteComponent(
    () => import('@/features/auth/AcceptInviteContent'),
    'AcceptInviteContent',
  ),
});
